/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState, startTransition } from 'react'
import { Flex, Stack } from '@mantine/core'
import { MRT_ColumnDef, MRT_PaginationState } from 'mantine-react-table'
import {
	blockUserTemp,
	getCmsUserList,
	getListUser,
	syncAddressLocalForSearchInApp,
	unBlockUserTemp,
	setVerifyUser,
	setVerifyRegularUser
} from 'src/apis/userAPI'
import CustomClearInput from 'src/components/CustomComponents/CustomClearInput'
import CustomSelect from 'src/components/CustomComponents/CustomSelect'
import TableComponent from 'src/components/TableComponent'
import actionClasses from 'src/components/TableComponent/TableComponent.module.scss'
import { FieldType } from 'src/interfaces'
import { filterUserPageList } from 'src/utils/filter'
import { mapUserListRows, UserTableRow, USER_LIST_API_FIELDS } from 'src/utils/mapUserListRows'
import { color } from 'src/variable/constant'
import CustomButton from 'src/components/CustomComponents/CustomButton'
import CustomProgress from 'src/components/CustomComponents/CustomProgress'
import ModalCreateGuider from './ModalCreateGuider'
import { useModal } from 'src/context/ModalContext'
import { useLoading } from 'src/context/LoadingContext'
import { GppMaybe, ToggleOff, ToggleOn, MyLocation, VerifiedUser } from '@mui/icons-material'
import ModalForm from 'src/components/Modal/ModalForm'
import { Button, TextField, Typography } from '@mui/material'
import ModalUpdateUserAddress from './ModalUpdateUserAddress'
import CustomTooltip from 'src/components/CustomComponents/CustomTooltip'
import ModalCreateNormalUser from './ModalCreateNormalUser'
import { useSearchParams } from 'react-router-dom'
import { resolveUserListQuery } from 'src/utils/userLocationFilter'
import { UserTableSkeleton } from './UserTableSkeleton'

const blockTypeOpts = [
	{
		label: 'One day',
		value: 'ONE_DAY',
	},
	{
		label: 'Three days',
		value: 'THREE_DAYS',
	},
	{
		label: 'Permanent',
		value: 'FOREVER',
	},
]

export const resolveUserStatusFilter = (status: string) => {
	const userStatusFilter = {
		deleted_at: null,
		blocked_at: null,
		userx_temp: null,
	}

	switch (status) {
		case 'All':
			userStatusFilter.userx_temp = 'All'
			break
		case 'Active':
			userStatusFilter.deleted_at = { $is: null }
			break
		case 'Deleted':
			userStatusFilter.deleted_at = { $not: null }
			break
		case 'Blocked':
			userStatusFilter.blocked_at = 'BLOCKED'
			break
		default:
			// VIP active, UniVini staff, Regular, Suggested for tick: the server filters by the status
			// parameter alone. The marker keeps the list refetching when the choice changes (the refetch
			// effect watches these three fields, and all-null never triggered it).
			userStatusFilter.userx_temp = status
			break
	}

	return userStatusFilter
}
interface UserPageListProps {
	columns: MRT_ColumnDef[]
	type?: string
	showManagementActions?: boolean
	showStatusFilter?: boolean
	showSearchFieldSelector?: boolean
	locationFilter?: {
		field: 'country' | 'province'
		value: string
	}
	fields: FieldType[]
	handleDetail: (row: any) => void
	selectOption?: {
		label: string
		value: any
	}[]
	[key: string]: any
}

function UserPageList({
	columns,
	type = 'USER',
	showManagementActions = true,
	showStatusFilter = true,
	showSearchFieldSelector = true,
	locationFilter,
	fields,
	handleDetail,
	selectOption = null,
}: UserPageListProps) {
	const { openError, openModal, closeModal } = useModal()
	const [urlSearchParams] = useSearchParams()
	const initialQueryRef = useRef<ReturnType<typeof resolveUserListQuery> | null>(null)
	if (!initialQueryRef.current) {
		initialQueryRef.current = resolveUserListQuery(urlSearchParams, {
			allowedSearchFields: locationFilter ? ['name'] : fields.map((item) => item.value),
			defaultSearchField: locationFilter ? 'name' : fields[0]?.value || 'name',
			allowedStatuses: (selectOption || []).map((item) => item.value),
		})
	}
	const initialQuery = initialQueryRef.current
	const initialSearchValue = locationFilter ? null : initialQuery.searchValue
	const [openModalBlock, setOpenModalBlock] = useState(false)
	const [formBlock, setFormBlock] = useState({ reason: '', type: '', user_id: '' })
	const [userStatus, setUserStatus] = useState(initialQuery.status)

	const handleChangeBlock = (e, name?: string) => {
		setFormBlock({ ...formBlock, [e.target?.name ?? name]: e.target.value })
	}

	const handleSubmitBlock = async () => {
		try {
			const res = await blockUserTemp({ ...formBlock });
			if (res?.data?.code === 200) {
				await handleGetData()
				setFormBlock({ reason: '', type: '', user_id: '' })
				openModal({
					type: 'success',
					label: `User has been blocked successfully `,
				})
				setOpenModalBlock(false)
			}
		} catch (error) {
			openError(error)
		} finally {
			// closeLoadingContext()
			setOpenModalBlock(false)

		}
	}
	const { openLoadingContext, closeLoadingContext } = useLoading()
	const [data, setData] = useState<UserTableRow[]>([])
	const [pagination, setPagination] = useState<MRT_PaginationState>({
		pageIndex: initialQuery.page,
		pageSize: initialQuery.limit,
	})
	const [value, setValue] = useState({
		field: initialQuery.searchField,
		value: initialSearchValue,
		...resolveUserStatusFilter(initialQuery.status),
	})
	const [searchInput, setSearchInput] = useState(initialSearchValue || '')
	const valueRef = useRef(value)
	valueRef.current = value
	const lastSearchAtRef = useRef(0)
	const skipPaginationFetchRef = useRef(false)
	const skipSearchDebounceRef = useRef(true)
	const runSearchRef = useRef<() => Promise<void>>(() => Promise.resolve())
	const requestAbortRef = useRef<AbortController | null>(null)
	const requestSequenceRef = useRef(0)
	const pendingTableUpdateRef = useRef<number | null>(null)
	const hasAppliedInitialStatusRef = useRef(false)
	const [total, setTotal] = useState<number>(0)
	const [loading, setLoading] = useState<boolean>(type === 'USER')
	const [open, setOpen] = useState<boolean>(false)
	const [openCreateNormalUser, setOpenCreateNormalUser] = useState<boolean>(false)
	const [openUpdateAddress, setOpenUpdateAddress] = useState<boolean>(false)
	const [selectedAddressUser, setSelectedAddressUser] = useState<UserTableRow | null>(null)
	const [syncProgress, setSyncProgress] = useState({
		total: 0,
		processed: 0,
		updated: 0,
		skipped: 0,
		failed: 0,
		percent: 0,
		status: '',
	})
	const [syncingAddress, setSyncingAddress] = useState<boolean>(false)
	const showInitialUserSkeleton = type === 'USER' && loading && data.length === 0
	const blockingUserName = data.find((item) => item.id === formBlock.user_id)?.name

	const getUserListFields = useCallback(
		() =>
			type !== 'GUIDER'
				? [...USER_LIST_API_FIELDS, '$paranoid']
				: [...USER_LIST_API_FIELDS],
		[type],
	)

	const applyUserTableData = useCallback((arr: UserTableRow[], count: number) => {
		if (pendingTableUpdateRef.current !== null) {
			cancelAnimationFrame(pendingTableUpdateRef.current)
		}
		pendingTableUpdateRef.current = requestAnimationFrame(() => {
			startTransition(() => {
				setData(arr)
				setTotal(count)
			})
			pendingTableUpdateRef.current = null
		})
	}, [])

	const handleGetData = useCallback(async (
		searchOverride?: string | null,
		pageOverride?: number,
	) => {
		requestAbortRef.current?.abort()
		const abortController = new AbortController()
		requestAbortRef.current = abortController
		const requestSequence = ++requestSequenceRef.current
		let arr: UserTableRow[] = []
		let count: number = 0
		const page = pageOverride ?? pagination.pageIndex
		const requestStartedAt = performance.now()
		let responseReceivedAt: number | null = null
		setLoading(true)
		try {
			const queryValue =
				searchOverride !== undefined
					? searchOverride
					: valueRef.current.value
			const res = type === 'USER'
				? await getCmsUserList({
					page,
					limit: pagination.pageSize,
					search_field: valueRef.current.field,
					search_key: queryValue || undefined,
					location_field: locationFilter?.field,
					location_key: locationFilter?.value,
					status: userStatus,
				}, abortController.signal)
				: await getListUser({
					fields: getUserListFields(),
					page,
					limit: pagination.pageSize,
					where: filterUserPageList({
						...valueRef.current,
						value: queryValue || null,
					}, { account_type: type }),
				})
			const rows = res?.data?.results?.objects?.rows ?? []
			responseReceivedAt = performance.now()
			arr = mapUserListRows(rows, page, pagination.pageSize)
			count = res?.data?.results?.objects?.count ?? 0
		} catch (error) {
			if (error?.code !== 'ERR_CANCELED') {
				openError(error)
			}
		} finally {
			if (requestSequence === requestSequenceRef.current) {
				applyUserTableData(arr, count)
				if (process.env.NODE_ENV !== 'production' && responseReceivedAt !== null) {
					console.debug('[Users table timing]', {
						requestMs: Math.round(responseReceivedAt - requestStartedAt),
						mapMs: Math.round(performance.now() - responseReceivedAt),
						rows: arr.length,
					})
				}
				setLoading(false)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [JSON.stringify(pagination), type, applyUserTableData, getUserListFields, locationFilter, userStatus])

	useEffect(
		() => () => {
			requestAbortRef.current?.abort()
			if (pendingTableUpdateRef.current !== null) {
				cancelAnimationFrame(pendingTableUpdateRef.current)
			}
		},
		[],
	)

	const handleSetValue = (e, key) => {
		if (key === 'field' && !searchInput.trim()) {
			setValue((pre) => ({ ...pre, [key]: e, value: null }))
		} if (key === 'user_status') {
			setUserStatus(e)
			setValue((pre) => ({ ...pre, ...resolveUserStatusFilter(e) }))
		}
		else {
			setValue((pre) => ({ ...pre, [key]: e }))
		}
	}

	const handleSearchQueryInit = useCallback((queryValue: string) => {
		const normalizedQueryValue = queryValue?.trim() || ''

		setSearchInput(normalizedQueryValue)
		setValue((pre) => ({
			...pre,
			value: normalizedQueryValue || null,
		}))
	}, [])

	const handleFilterQueryInit = useCallback(
		(query: Record<string, string>) => {
			const fieldFromQuery = query.search_field
			const validField = fields.some((item) => item.value === fieldFromQuery)
				? fieldFromQuery
				: fields[0]?.value

			const statusFromQuery = query.status
			const validStatuses = (selectOption || []).map((item) => item.value)
			const nextStatus = validStatuses.includes(statusFromQuery)
				? statusFromQuery
				: 'All'

			if (validField) {
				setValue((pre) =>
					pre.field === validField ? pre : { ...pre, field: validField },
				)
			}

			if (nextStatus !== userStatus) {
				setUserStatus(nextStatus)
				setValue((pre) => ({
					...pre,
					...resolveUserStatusFilter(nextStatus),
				}))
			}
		},
		[fields, selectOption, userStatus],
	)

	const handleChangePage = useCallback((value: number) => {
		setPagination((pre) => ({
			...pre,
			pageIndex: value,
		}))
	}, [])

	const handleChangePageSize = useCallback((value: number) => {
		setPagination((pre) => ({
			...pre,
			pageSize: value,
		}))
	}, [])

	const runSearch = useCallback(async () => {
		const now = Date.now()
		if (now - lastSearchAtRef.current < 400) {
			return
		}
		lastSearchAtRef.current = now

		const normalized = searchInput.trim() || null
		const nextValue = { ...valueRef.current, value: normalized }
		valueRef.current = nextValue

		if (pagination.pageIndex !== 1) {
			skipPaginationFetchRef.current = true
			handleChangePage(1)
		}

		await handleGetData(normalized, 1)
		setValue(nextValue)
	}, [handleChangePage, handleGetData, pagination.pageIndex, searchInput])

	const handleSearchSubmit = useCallback(
		(event: React.FormEvent<HTMLFormElement>) => {
			event.preventDefault()
			runSearch()
		},
		[runSearch],
	)

	runSearchRef.current = runSearch

	useEffect(() => {
		const timer = setTimeout(() => {
			if (skipSearchDebounceRef.current) {
				skipSearchDebounceRef.current = false
				return
			}
			runSearchRef.current()
		}, 500)

		return () => clearTimeout(timer)
	}, [searchInput])

	const handleUnBlockUser = useCallback(async ({ id, isBlocked }) => {
		openLoadingContext()
		try {
			if (!isBlocked) {
				const res = await unBlockUserTemp({
					user_id: id,
				})
				if (res?.data?.code === 200) {
					const newDataItem = res.data?.results.object
					setData((pre) =>
						pre.map((item) =>
							item.id === id ? { ...item, blocked_at: newDataItem?.blocked_at } : item,
						),
					)
					openModal({
						type: 'success',
						label: `User has been un-blocked successfully `,
					})
				}
			} else {
				setOpenModalBlock(true)
				setFormBlock({ reason: '', type: 'ONE_DAY', user_id: id })
			}

		} catch (error) {
			openError(error)
		} finally {
			closeLoadingContext()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleToggleVerify = useCallback(async ({ id, is_verified }: { id: string; is_verified: boolean }) => {
		openLoadingContext()
		try {
			const res = await setVerifyUser(id, !is_verified)
			if (res?.data?.code === 200) {
				setData((pre) =>
					pre.map((item) =>
						item.id === id ? { ...item, is_verified: !is_verified } : item,
					),
				)
				openModal({
					type: 'success',
					label: `User has been ${!is_verified ? 'verified' : 'unverified'} successfully`,
				})
			}
		} catch (error) {
			openError(error)
		} finally {
			closeLoadingContext()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleToggleVerifyRegular = useCallback(async ({ id, is_regular }: { id: string; is_regular: boolean }) => {
		openLoadingContext()
		try {
			const res = await setVerifyRegularUser(id, !is_regular)
			if (res?.data?.code === 200) {
				setData((pre) =>
					pre.map((item) =>
						item.id === id ? { ...item, is_regular: !is_regular } : item,
					),
				)
				openModal({
					type: 'success',
					label: `User has been ${!is_regular ? 'Verified' : 'UnVerified'} Regular User successfully`,
				})
			}
		} catch (error) {
			openError(error)
		} finally {
			closeLoadingContext()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleOpenToggleVerify = useCallback(({ id, is_verified }) => {
		openModal({
			type: 'confirm',
			label: (
				<>
				{is_verified && (
					<>
						Remove from UniVini team!
					</>
				)}
				{!is_verified && (
					<>
					<div>Do you want to {is_verified ? 'UnVerify UniVini' : 'verify UniVini'} this user?</div>
					<div>UniVini team (can block users)</div>
					</>
				)}
				</>
			),
			handleConfirm: () => {
				handleToggleVerify({ id, is_verified })
			},
		})
	}, [handleToggleVerify, openModal])

	const handleOpenToggleVerifyRegular = useCallback(({ id, is_regular }) => {
		openModal({
			type: 'confirm',
			label: (
				<>
				{is_regular && (
					<>
						Remove from Regular User!
					</>
				)}
				{!is_regular && (
					<>
					<div>Do you want to {is_regular ? 'UnVerify  Regular User' : 'verify  Regular User'} this user?</div>
					<div>Regular users(can not block users) </div>
					</>
				)}

				</>
			),
			handleConfirm: () => {
				handleToggleVerifyRegular({ id, is_regular })
			},
		})
	}, [handleToggleVerify, openModal])

	const handleOpenUpdateStatus = useCallback(async ({ id, isBlocked }) => {
		if (isBlocked) {
			setFormBlock({ reason: '', type: 'ONE_DAY', user_id: id })
			setOpenModalBlock(true)
		} else {
			openModal({
				type: 'confirm',
				label: (
					<div>Do you want to unblock this user?</div>
				),
				handleConfirm: () => {
					handleUnBlockUser({ id, isBlocked })
				},
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleSyncAddressLocal = useCallback(async () => {
		closeModal()
		setSyncingAddress(true)
		setSyncProgress({
			total: 0,
			processed: 0,
			updated: 0,
			skipped: 0,
			failed: 0,
			percent: 0,
			status: 'processing',
		})
		try {
			let finalResult = null
			await syncAddressLocalForSearchInApp(({ event, data }) => {
				if (event === 'progress') {
					setSyncProgress(data)
				}
				if (event === 'completed') {
					finalResult = data
					setSyncProgress((pre) => ({
						...pre,
						...data,
						percent: 100,
						status: 'completed',
					}))
				}
				if (event === 'error') {
					throw new Error(data?.message || 'Sync location failed')
				}
			})

			if (finalResult) {
				openModal({
					type: 'success',
					label: `Sync location successfully. Total: ${finalResult?.total ?? 0
						}, updated: ${finalResult?.updated ?? 0}, skipped: ${finalResult?.skipped ?? 0
						}, failed: ${finalResult?.failed ?? 0}`,
				})
			}
		} catch (error) {
			openError(error)
		} finally {
			setSyncingAddress(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleConfirmSyncAddressLocal = useCallback(() => {
		openModal({
			type: 'confirm',
			label: (
				<div>
					Would you like to synchronize location from GPS to local location for users who lack a local address?
				</div>
			),
			handleConfirm: handleSyncAddressLocal,
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [handleSyncAddressLocal])

	const handleOpenUpdateAddress = useCallback((user) => {
		setSelectedAddressUser(user)
		setOpenUpdateAddress(true)
	}, [])

	const handleCloseUpdateAddress = useCallback(() => {
		setOpenUpdateAddress(false)
		setSelectedAddressUser(null)
	}, [])

	const handleUpdateAddressSuccess = useCallback((updatedUser) => {
		setData((pre) =>
			pre.map((item) =>
				item.id === updatedUser?.id
					? {
						...item,
						...updatedUser,
						no: item.no,
						created_at: item.created_at,
					}
					: item,
			),
		)
	}, [])

	const _renderCustomActions = useCallback(
		(row) => {
			const { id, blocked_at, is_verified, is_regular, deleted_at } = row?.original
			if (deleted_at) return null

			const BlockIcon = blocked_at ? ToggleOff : ToggleOn
			const blockLabel = blocked_at ? 'UnBlock' : 'Block'
			const VerifyIcon = is_verified ? VerifiedUser : GppMaybe
			const verifyUniViniLabel = is_verified ? 'Unverify UniVini' : 'Verify UniVini'
			const verifyregularLabel = is_regular ? 'Unverify Regular User' : 'Verify Regular User'
			return (
				<>
					<Stack sx={{ order: 30 }}>
						<button
							type="button"
							className={`${actionClasses.actionButton} ${actionClasses.primaryAction}`}
							onClick={() => handleOpenUpdateAddress(row?.original)}
							title="Update address from GPS"
							aria-label="Update address from GPS"
						>
							<MyLocation fontSize="small" />
						</button>
					</Stack>
					<Stack sx={{ order: 40 }}>
						<button
							type="button"
							className={`${actionClasses.actionButton} ${
								!blocked_at ? actionClasses.dangerAction : actionClasses.primaryAction
							}`}
							onClick={() => handleOpenUpdateStatus({ id, isBlocked: !blocked_at })}
							title={blockLabel}
							aria-label={blockLabel}
						>
							<BlockIcon fontSize="small" />
						</button>
					</Stack>
					<Stack sx={{ order: 50 }}>
						<button
							type="button"
							className={`${actionClasses.actionButton} ${
								is_verified ? actionClasses.primaryAction : actionClasses.mutedAction
							}`}
							onClick={() => handleOpenToggleVerify({ id, is_verified: !!is_verified })}
							title={verifyUniViniLabel}
							aria-label={verifyUniViniLabel}
						>
							<VerifyIcon fontSize="small" />
						</button>
					</Stack>
					<Stack sx={{ order: 50 }}>
						<button
							type="button"
							className={`${actionClasses.actionButton} ${
								is_regular ? actionClasses.primaryAction : actionClasses.mutedAction
							}`}
							onClick={() => handleOpenToggleVerifyRegular({ id, is_regular: !!is_regular })}
							title={verifyregularLabel}
							aria-label={verifyregularLabel}
						>
							<VerifyIcon fontSize="small" />
						</button>
					</Stack>
				</>
			)
		},
			[handleOpenUpdateStatus, handleOpenToggleVerifyRegular, handleOpenToggleVerify],
	)
	useEffect(() => {
		if (skipPaginationFetchRef.current) {
			skipPaginationFetchRef.current = false
			return
		}
		handleGetData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [JSON.stringify(pagination)])

	useEffect(() => {
		if (!hasAppliedInitialStatusRef.current) {
			hasAppliedInitialStatusRef.current = true
			return
		}

		if (
			value.deleted_at !== null ||
			value.blocked_at !== null ||
			value.userx_temp !== null
		) {
			if (pagination.pageIndex === 1) {
				handleGetData()
			} else {
				handleChangePage(1)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value.deleted_at, value.blocked_at, value.userx_temp, value.field])

	return (
		<Stack sx={{ width: '100%' }}>
			<Flex
				gap={8}
				justify="space-between"
				sx={{ flexWrap: 'wrap' }}
				align="center"
			>
				<form
					noValidate
					onSubmit={handleSearchSubmit}
					style={{ margin: 0, display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
				>
						{showSearchFieldSelector && (
							<CustomSelect
								value={value.field}
								data={fields}
								onChange={(e) => {
									handleSetValue(e, 'field')
								}}
							/>
						)}
						<CustomClearInput
							value={searchInput}
							onChange={setSearchInput}
							placeholder={locationFilter ? 'Search name' : 'Search'}
							autoComplete="off"
							enterKeyHint="search"
							inputMode="search"
							onEnterPress={runSearch}
						/>
						{selectOption && showStatusFilter && (
							<CustomSelect
								data={selectOption}
								value={userStatus}
								placeholder="State account"
								onChange={(e) => handleSetValue(e, 'user_status')}
							/>
						)}
				</form>
				{type !== 'GUIDER' && (
					<Flex
						gap={8}
						align="center"
						justify="flex-end"
						sx={{ fontSize: 20, fontWeight: 600, color: color.CmsPrimary }}
					>
						<div>Total: {total || ''}</div>

						{showManagementActions && (
							<CustomTooltip label="Đồng bộ vị trí local cho user còn thiếu address_local để phục vụ search in app">
								<Button
									type="button"
									variant="outlined"
									sx={{
										height: '32px',
										minWidth: '120px',
										whiteSpace: 'nowrap',
										fontSize: 13,
										fontWeight: 600,
									}}
									onClick={handleConfirmSyncAddressLocal}
									disabled={syncingAddress}
								>
									Sync location
								</Button>
							</CustomTooltip>
						)}
					</Flex>
				)}
				{type === 'GUIDER' && (
					<CustomButton
						type="button"
						variant="outlined"
						sx={{ height: '36px', whiteSpace: 'nowrap', minWidth: '240px' }}
						onClick={() => setOpen(true)}
					>
						Create
					</CustomButton>
				)}
				{type === 'USER' && showManagementActions && (
					<CustomButton
						type="button"
						variant="outlined"
						sx={{ height: '36px', whiteSpace: 'nowrap', minWidth: '240px' }}
						onClick={() => setOpenCreateNormalUser(true)}
					>
						Create New User
					</CustomButton>
				)}
			</Flex>

			{syncingAddress && (
				<Stack spacing={4}>
					<Flex justify="space-between" sx={{ fontSize: 13 }}>
						<div>
							Syncing location: {syncProgress.processed}/{syncProgress.total}
						</div>
						<div>
							Updated: {syncProgress.updated} | Skipped: {syncProgress.skipped} |
							Failed: {syncProgress.failed}
						</div>
					</Flex>
					<CustomProgress value={syncProgress.percent} />
				</Stack>
			)}
			{showInitialUserSkeleton ? (
				<UserTableSkeleton />
			) : (
				<TableComponent
					columns={columns}
					total={total}
					data={data}
					pagination={pagination}
					loading={loading}
					lean={type === 'USER'}
					compact={type === 'USER'}
					handleChangePage={handleChangePage}
					handleChangePageSize={handleChangePageSize}
					syncQueryUrl={!locationFilter}
					searchQueryKey="search_key"
					searchQueryValue={typeof value.value === 'string' ? value.value : undefined}
					onSearchQueryInit={handleSearchQueryInit}
					filterQueryValues={{
						search_field: value.value ? value.field : undefined,
						status: userStatus !== 'All' ? userStatus : undefined,
					}}
					onFilterQueryInit={handleFilterQueryInit}
					handleDetail={handleDetail}
					hideMoreActions={type === 'USER'}
					disableActionTooltips={type === 'USER'}
					_renderCustomActions={_renderCustomActions}
				// handleDelete={handleConfirmDelete}
				/>
			)}
			{open && (
				<ModalCreateGuider
					open={open}
					onClose={() => setOpen(false)}
					handleGetData={handleGetData}
					pagination={pagination}
					handleChangePage={handleChangePage}
				/>
			)}
			{openCreateNormalUser && (
				<ModalCreateNormalUser
					open={openCreateNormalUser}
					onClose={() => setOpenCreateNormalUser(false)}
					handleGetData={handleGetData}
					pagination={pagination}
					handleChangePage={handleChangePage}
				/>
			)}
			<ModalUpdateUserAddress
				open={openUpdateAddress}
				user={selectedAddressUser}
				onClose={handleCloseUpdateAddress}
				onSuccess={handleUpdateAddressSuccess}
			/>
			<ModalForm
				open={openModalBlock}
				handleClose={() => setOpenModalBlock(false)}
				handleSubmit={handleSubmitBlock}
			>
				<Stack spacing={2} sx={{ width: '300px' }}>
					<Typography variant="h6" textAlign="center">
						Enter reason and type for blocking
						{blockingUserName ? (
							<>
								{': '}
								<strong>{blockingUserName}</strong>
							</>
						) : null}
					</Typography>
					<Typography sx={{ textAlign: 'start', width: '100%' }}>{'Reason:'}</Typography>
					<TextField
						label="Reason"
						name="reason"
						value={formBlock.reason}
						onChange={handleChangeBlock}
						fullWidth
					/>

					<Typography sx={{ textAlign: 'start', width: '100%' }}>{'Type:'}</Typography>
					<Stack className='w-100 justify-content-center' spacing={1}>
						<CustomSelect
							data={blockTypeOpts}
							value={formBlock.type}
							placeholder="Type"
							onChange={(value) => {
								setFormBlock({ ...formBlock, type: value })
							}}
						/>
					</Stack>
				</Stack>
			</ModalForm>
		</Stack>
	)
}

export default React.memo(UserPageList)
